module.exports = __webpack_public_path__ + "img/scheduleAlert.f0783c38.svg";